/* eslint-disable quotes */
import bp from './breakpoints';

const MQ = {
  mobile: `${bp.mobile}px`,
  tabletSmall: `${bp.tabletSmall}px`,
  tablet: `${bp.tablet}px`,
  desktop: `${bp.desktop}px`,
};

export const BZ = `
  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  `;

export const FONTS = {
  heading: `'Inter', system-ui, sans-serif`,
  body: `'Inter', system-ui, sans-serif`,
};

export const COLORS = {
  // Orange + blue palette matching the Decorzo Space logo
  accent: '#F08020', // Logo orange - primary accent
  accentLight: '#F4A040', // Lighter orange
  accentDark: '#C95E0F', // Darker orange
  blue: '#1378E5', // Logo blue - secondary accent
  blueLight: '#4A99EC', // Lighter blue
  blueDark: '#0B5DB8', // Darker blue
  dark: '#1378E5', // Logo blue - used on dark surfaces
  darkSoft: '#0B5DB8', // Darker blue for layered/accent surfaces
  cream: '#F2F6FC', // Cool light background (replaces warm cream)
  warmWhite: '#F8FAFC', // Cool off-white
  stone: '#DCE5F0', // Cool stone
  text: '#1B2733', // Cool dark slate for body text
  textMuted: '#5B6B7C', // Cool muted slate
  textLight: '#9FB0C3', // Cool light slate
  border: '#D8E1EC', // Cool border

  // Legacy mappings
  orange: '#F7941D',
  light: '#F2F6FC',
  neutral50: '#F8FAFC',
  neutral100: '#F2F6FC',
  neutral200: '#DCE5F0',
  neutral300: '#C7D2E0',
  neutral400: '#9FB0C3',
  neutral500: '#5B6B7C',
  neutral600: '#3A4756',
  neutral700: '#1B2733',
  neutral800: '#0B5DB8',
  neutral900: '#1378E5',
  themeOrange: '#F7941D',
  themeBlue: '#1378E5',
};

export const Z = {
  modalBackground: `z-index: 100000;`,
  modal: `z-index: 200000;`,
};

export const DURATION = 500;
